import React from "react";

export default function TermsConditions() {
  return (
    <section className="terms-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="primary-heading color-dark">
          <h3 className="mb-3">Terms &amp; Conditions</h3>
          <h5>1. Acceptance of Terms</h5>
          <p className="text-justify">
            By accessing or using the Bnr360 freelance platform ("Platform"),
            you agree to comply with and be bound by these terms and conditions.
            If you do not agree to these terms, please do not use the Platform.
          </p>
          <h5>2. User Eligibility</h5>
          <p className="text-justify">
            To use the Platform, you must be at least 18 years old and capable
            of forming a binding contract. By using the Platform, you represent
            and warrant that you meet these eligibility requirements.
          </p>
          <h5>3. User Registration</h5>
          <p className="text-justify">
            You may be required to register an account with Bnr360 to access
            certain features of the Platform. You are responsible for providing
            accurate and current information during the registration process and
            for keeping your login credentials confidential. Bnr360 reserves the
            right to suspend or terminate your account if any information
            provided is found to be inaccurate or if there is a breach of
            security.
          </p>
          <h5>4. Freelancer-Client Relationship</h5>
          <p className="text-justify">
            Bnr360 acts as a platform to connect freelancers and clients. Bnr360
            is not a party to any agreements or contracts between freelancers
            and clients. Bnr360 is not responsible for the quality, timing, or
            legality of services provided by freelancers, nor for the actions or
            inactions of clients.
          </p>
          <h5>5. Payment and Fees</h5>
          <p className="text-justify">
            Clients agree to pay freelancers for services rendered through the
            Platform. Bnr360 may charge fees for the use of its services, which
            will be clearly outlined. Payment transactions are processed through
            secure third-party payment providers.
          </p>
          <h5>6. Dispute Resolution</h5>
          <p className="text-justify">
            Any disputes between freelancers and clients should be resolved
            directly between the parties involved. Bnr360 may, at its
            discretion, provide dispute resolution assistance, but is not
            obligated to do so.
          </p>
          <h5>7. Code of Conduct</h5>
          <p className="text-justify">
            Users agree not to violate any applicable laws or regulations,
            engage in fraudulent activities, or infringe on the rights of others
            while using the Platform. Bnr360 reserves the right to suspend or
            terminate the accounts of users who violate this code of conduct.
          </p>
          <h5>8. Intellectual Property</h5>
          <p className="text-justify">
            Users retain ownership of their intellectual property rights. By
            using the Platform, users grant Bnr360 a non-exclusive, royalty-free
            license to use, display, and distribute their content for the
            purpose of providing and promoting the Platform.
          </p>
          <h5>9. Privacy Policy</h5>
          <p className="text-justify">
            By using the Platform, you agree to the terms outlined in the Bnr360
            Privacy Policy, which is available on the Platform.
          </p>
          <h5>10. Changes to Terms and Conditions</h5>
          <p className="text-justify">
            Bnr360 reserves the right to update or modify these terms and
            conditions at any time. Users will be notified of any changes, and
            continued use of the Platform constitutes acceptance of the modified
            terms.
          </p>
        </div>
      </div>
    </section>
  );
}
